import { OptionalWithDefaultInjectionFacade as o } from "./optional-with-default-injection-facade.js";
import { DefaultErrorLogger as t } from "../error-logger/default-error-logger.js";
class r extends o {
  static KEY = Symbol("error-logger");
  constructor() {
    super(r.KEY, () => new t());
  }
}
export {
  r as ErrorLoggerInjectionFacade
};
//# sourceMappingURL=error-logger-injection-facade.js.map
